import apiUrl from '../../../constants'
import user_tracker from '../../../usertracker'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading'
import utils from '../../../utils/validateScanner.js'
import {
  buildConnectionsSearchPayload,
  CONNECTION_SEARCH_PURPOSE,
  getConnectionsSearchUrl
} from '../../../utils/connectionsSearchApi.js';
export default {
  name: 'BaginProcess',
  mixins: [utils],
  components: {
    Paginate,
    DatePicker,
    BasicSelect,
    VueElementLoading
  },
  data: function() {
    return {
      userHubId: 0,
      showShipmentModel: false,
      showBagSealNoModel: false,
      type: '',
      bag: 'ParentBag',
      bagType: '',
      bagSubType: '',
      connection: '',
      destinationHub: '',
      bagData: [{
        value: "ParentBag",
        text: "Parent Bag"
      }, {
        value: "ChildBag",
        text: "Child Bag"
      }],
      bagObjData: {
        value: "ParentBag",
        text: "Parent Bag"
      },
      bagTypeData: [],
      bagTypeObjData: {
        text: ""
      },
      bagSubTypeData: [],
      bagSubTypeObjData: {
        text: ""
      },
      connectionData: [],
      connectionObjData: {
        value: "",
        text: "",
        destHub: ""
      },
      destinationHubData: [],
      destinationHubObjData: {
        value: "",
        text: "",
        isbaggingpattern: "",
        groupid: ""
      },
      bagSealNumber: '',
      awbBag: '',
      weight: '',
      comment: '',
      shippingId: '',
      connectionType: '',
      connectionTypeList: [],
      connectionTypeItem: {
        value: "",
        text: ""
      },
      connectionDesHubId: '',
      hubName: '',
      baginBagNo: '',
      baginBagStatus: '',
      baginBagType: '',
      reason: '',
      commentUpSlno: '',
      oldSealNo: '',
      newSealNo: '',
      baginCheck: true,
      shippingIdErrors: '',
      shipmentDetailsList: [],
      processCode: '',
      errorBagSealNo: '',
      oldSealNoErr: '',
      newSealNoErr: '',
      reasonErr: '',
      flagUpdateSealNo: false,
      inScanList: [],
      pendingList: [],
      openBagHubName: '',
      openbagList: [],
      awbBagErr: '',
      printBagStickerNo: '',
      childbagConfirmationModel: false,
      IsAllowXbSeries: 0,
      IsBikerBag: false,
      bagNoError: '',
      routeMode: '',
      routeModeData: [{
        text: "Air"
      }, {
        text: "Surface"
      }],
      routeModeObjData: {
        text: ""
      },
      isDisabledRouteMode: true,
      flagGerateBag: false,
      BaggingPatternData: [],
      NDDBagData: [],
      input: '',
      bagDetails: '',
      barcodeinput: false,
      timerenable: 1000,
      timerdisable: 1200,
      barcodecheck: 0,
      totalshipmentcount: 0,
      normalshipmentcount: 0,
      highvalueshipmentcount: 0,
      reversepickupshipmentcount: 0,
      viewdata: [],
      ClientWiseShipmentDetails: [],
      PendingListModal: false,
      isLoading: false,
      token: '',
      invalidTokenModal: false,
      invalidtokenmsg: '',
      isBrook: "",
      BagLoading: false,
      XBSealModel: false,
      xbsealreason: '',
      xbsealreasonErr: '',
      XBSealMsg: '',
      IsAllowXBSeal: false,
      timeoutHandler: 0,
			inputString:'',
			manualInput:false,
      isWeighingInfraAvailable:'',
      reversePickUpParentHubID:'',
      reversePickUpParentHubName:'',
      rtoBagParentHubId:'',
      rtoParentHubName:'',
			userData:[]
    }
  },

  created: function() {},
  computed: {},
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '-'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    jsUcfirst: function(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
  mounted() {
    var userTokenEncrypt = window.localStorage.getItem('userToken')
    var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
    var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    this.token = JSON.parse(userToken)
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.userData = userdetail;
    this.userHubId = userdetail[0].HubId[0] == undefined ? 0 : userdetail[0].HubId[0]
    this.createdBy = userdetail[0].email;
    this.today = new Date()
    this.getHubName(this.userHubId);
    user_tracker.checkUserIP(userdetail[0], "BaginProcess", this.$route.path);
    // this.loadConnections();
  },
  created() {
    // axios.interceptors.request.use((config) => {
    //   this.setLoading(true);
    //   return config;
    // }, (error) => {
    //   this.setLoading(false);
    //   return Promise.reject(error);
    // });
    //
    // axios.interceptors.response.use((response) => {
    //   this.setLoading(false);
    //   return response;
    // }, (error) => {
    //   this.setLoading(false);
    //   return Promise.reject(error);
    // });
  },
  methods: {
    validateBarcode(e){
			if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler)
      this.inputString += String.fromCharCode(e.keyCode)
    	}
			this.timeoutHandler = setTimeout(() => {
		 		if (this.inputString.length <= 3) {
			 		this.manualInput = true
			 		this.inputString = ''
		 		}else{
			 		this.manualInput = false
			 		this.inputString = ''
		 		}
	 		}, 10)
 		},
    scannerinput() {
      if (document.getElementById("scannerinput").checked == true) {
        this.barcodeinput = true
      } else {
        this.barcodeinput = false;
      }
    },
    checkBarcode(obj) {
      var obj = Number(obj);
      this.barcodecheck = this.barcodecheck + obj;
      if (this.barcodecheck == 1) {
        setTimeout(function() {
          document.getElementById("bagsealno").disabled = true;
        }, this.timerenable);
      }
    },
    getHubName(hubid) {
      this.CityId = 0
      this.input = {
        hubids: [hubid]
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.hubName = result.data.ResponseData[0].HubName;
            this.CityId = result.data.ResponseData[0].CityId == undefined || result.data.ResponseData[0].CityId == null ? 0 : result.data.ResponseData[0].CityId
            // this.isBrook=result.data.ResponseData[0].ConfigSetting.isbrook != undefined?result.data.ResponseData[0].ConfigSetting.isbrook:""
            this.isBrook = result.data.ResponseData[0].ConfigSetting.isbrook
            this.isWeighingInfraAvailable = result.data.ResponseData[0].IsWeighingInfraAvailable
            this.reversePickUpParentHubID = result.data.ResponseData[0].reversepickupparenthubid
            this.reversePickUpParentHubName= result.data.ResponseData[0].reversepickupparenthubname
            this.rtoBagParentHubId = result.data.ResponseData[0].RTOBagParentHubId
            this.rtoParentHubName = result.data.ResponseData[0].RTOParentHubName
            this.getRouteType(this.isBrook);
            this.loadBagTypes();
          } else {
            this.hubName = '';
          }
        }, error => {
          console.error(error)
        })
    },
    getRouteType(brook) {
      if(brook=="1"){
        this.connectionTypeList.push(
          {
           id: 5,
           text: 'BrooksNBonds'
         }
       )
      }
      else {
      this.connectionTypeList.push(
        // {
        //   id: 0,
        //   text: 'Network'
        // },
        {
          id: 1,
          text: 'Local'
        }, {
          id: 3,
          text: 'LineHaul'
        },
         {
          id: 5,
          text: 'BrooksNBonds'
        }
        //for LineHaul Biker
        // {
        //   id: 6,
        //   text: 'Biker'
        // }
      )
    }},
    selectConnectionType(obj) {
      this.connectionTypeItem = obj
      this.connectionType = obj.id

      this.bagTypeObjData = {
        text: ""
      }
      this.bagType = ""

      this.bagSubTypeObjData = {
        text: ""
      }
      this.bagSubType = ""

      this.resetValidator()
      this.loadConnections()
    },
    selectedBag(obj) {
      this.bagObjData = obj
      this.bag = obj.value
      // this.bagTypeObjData = { text: "" }
      // this.bagType = ""
      //
      // this.bagSubTypeObjData = { text: "" }
      // this.bagSubType = ""
      //
      // this.connectionData = []
      // this.connectionObjData = {text:"",value:"",destHub:""}
      // this.connection = ""
      //
      // this.destinationHubData = []
      // this.destinationHubObjData = {text:"",value:"",isbaggingpattern:"",groupid:""}
      // this.destinationHub = ""
      // this.bagSealNumber = ""
      this.resetValidator()
    },
    selectedBagType(obj) {
      this.bagSubTypeObjData = {
        text: ""
      }
      this.bagSubType = ""
      this.bagTypeObjData = obj
      this.bagType = obj.text
      if (obj.text == "MasterBag" && this.bag == "ChildBag") {
        this.bagObjData = {
          value: "ParentBag",
          text: "Parent Bag"
        }
        this.bag = "ParentBag"
      }
      this.routeMode = ''
      this.routeModeObjData = {
        text: ""
      }
      this.isDisabledRouteMode = true
      this.loadConnections()
    },
    selectedBagSubType(obj) {
      this.bagSubTypeObjData = obj
      this.bagSubType = obj.text
    },
    loadBagTypes() {
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'fetchBagTypes' + "?hubId=" + this.userHubId,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            var bagTypeData = result.data.ResponseData
            for (var i = 0; i < bagTypeData.bagType.length; i++) {
              this.bagTypeData.push({
                text: bagTypeData.bagType[i].bagtype
              })
            }
            for (var i = 0; i < bagTypeData.bagSubType.length; i++) {
              this.bagSubTypeData.push({
                text: bagTypeData.bagSubType[i].bagtype
              })
            }
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    loadConnections() {

      this.connectionData = []
      this.connectionObjData = {
        text: "",
        value: "",
        destHub: ""
      }
      this.connection = ""

      this.destinationHubData = []
      this.destinationHubObjData = {
        text: "",
        value: "",
        isbaggingpattern: "",
        groupid: ""
      }
      this.destinationHub = ""
      this.resetValidator()

      if (this.connectionType && this.userHubId) {
        this.input = buildConnectionsSearchPayload(CONNECTION_SEARCH_PURPOSE.SCHEDULE, {
          type: this.connectionType,
          source: this.userHubId
        })
        axios({
            method: 'POST',
           // url: apiUrl.api_url_hubops + 'getConnectionList',
            url: getConnectionsSearchUrl(),
            data: this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              var connectionData = result.data.ResponseData
              this.invalidTokenModal = false
              for (var i = 0; i < connectionData.length; i++) {
                // if (this.connectionTypeItem.text == 'Biker') {
                //   this.connectionData.push({
                //     value: connectionData[i].ConnectionID,
                //     text: connectionData[i].FullConnectionName,
                //     destHub: connectionData[i].DestinationHubID
                //   })
                // } else {
                this.connectionData.push({
                  value: connectionData[i].ConnectionID,
                  text: connectionData[i].ConnectionName,
                  destHub: connectionData[i].DestinationHubID
                })
                // }
              }
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      }
    },
    closeinvalidTokenModal() {
      this.invalidTokenModal = false
      this.invalidtokenmsg = ''
    },
    logout(e) {
      localStorage.removeItem('permissiondata')
      localStorage.removeItem('userdetail')
      localStorage.removeItem('userToken')
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('loginDate')
      this.$router.push('/login')
      e.preventDefault()
    },
    selectedConnection(obj) {
      this.connectionObjData = obj
      this.connection = obj.value
      this.connectionDesHubId = obj.destHub
      this.loadDestinationHub();
    },
    loadDestinationHub() {
      this.destinationHubData = []
      var bagType = ''
      this.destinationHubObjData = {
        text: "",
        value: "",
        isbaggingpattern: "",
        groupid: ""
      }
      this.destinationHub = ""
      this.resetValidator()
      if (this.bagType != "") {
        if (this.bagType == 'MasterBag') {
          bagType = this.bagSubType
        } else {
          bagType = this.bagType
        }
        axios({
            method: 'GET',
            url: apiUrl.api_url_hubops + 'getDestinationHubsForConnection?connectionId=' + this.connection + '&bagType=' + bagType + '&isBrook=' + this.isBrook + '&currentHubId=' + this.userHubId,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              var destinationHubData = result.data.ResponseData
              for (var i = 0; i < destinationHubData.length; i++) {
                this.destinationHubData.push({
                  value: destinationHubData[i].parenthubid,
                  text: destinationHubData[i].hubname,
                  isbaggingpattern: destinationHubData[i].isbaggingpattern,
                  groupid: destinationHubData[i].groupid,
                  isgroup: destinationHubData[i].isgroup
                })
              }
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      } else {
        // this.$alertify.error("The Bag Type field is required")
      }
    },
    selectedDestinationHub(obj) {
      this.destinationHubObjData = obj
      this.destinationHub = obj.value
      if (this.destinationHubObjData.text == '') {
        this.destinationHubObjData.isbaggingpattern = false
        this.routeModeObjData = {
          text: ""
        }
        this.routeMode = ""
        this.isDisabledRouteMode = true
      }
      this.printBagStickerNo = ''
      if (obj.isbaggingpattern == true && (this.bagType == "AirBag" || this.bagType == "AirCargoBag" || this.bagType == "NDDBag" || this.bagType == "DOCBag")) {
        this.routeModeObjData = {
          text: "Air"
        }
        this.routeMode = "Air"
      } else if (obj.isbaggingpattern == true && this.bagType == "MasterBag" && (this.bagSubType == "AirBag" || this.bagSubType == "AirCargoBag" || this.bagSubType == "NDDBag" || this.bagSubType == "DOCBag")) {
        this.routeModeObjData = {
          text: "Air"
        }
        this.routeMode = "Air"
      } else if (obj.isbaggingpattern == true && (this.bagType == "RSCBag" || this.bagSubType == "RSCBag" || this.bagSubType == "MixedBag")) {
        //full open route mode
        this.isDisabledRouteMode = false
      } else if (obj.isbaggingpattern == true && this.bagType == "RtoBag") {
        //full open route mode
        this.isDisabledRouteMode = false
      } else if (obj.isbaggingpattern == true) {
        this.routeModeObjData = {
          text: "Surface"
        }
        this.routeMode = "Surface"
      }
      if (this.destinationHubObjData.isgroup == 1) {
        this.input = {
          "connectionId": this.connection,
          "groupId": this.destinationHubObjData.groupid,
          "bagType": this.bagType
        }
        axios({
            method: 'POST',
            data: this.input,
            url: apiUrl.api_url_hubops + 'getBaggingPattern',
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.BaggingPatternData = result.data.ResponseData
              this.destinationHub = this.BaggingPatternData.parenthubid
              if (this.BaggingPatternData.isbaggingpattern == true) {
                this.destinationHubObjData.isbaggingpattern = true
                this.routeModeObjData.text = this.BaggingPatternData.routemode
                this.routeMode = this.BaggingPatternData.routemode
              } else {
                this.destinationHubObjData.isbaggingpattern = false
                this.routeModeObjData = {
                  text: ""
                }
                this.routeMode = ""
              }
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.destinationHub = ""
              this.destinationHubObjData = {
                  value: "",
                  text: "",
                  isbaggingpattern: "",
                  groupid: ""
                },
                this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      }
      if (this.bagType == "NDDBag") {
        axios({
            method: 'GET',
            url: apiUrl.api_url_hubops + 'getDestinationsForNDDBag?connectionId=' + this.connection + "&hubid=" + this.destinationHub + "&bagtype=" + this.bagType,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.NDDBagData = result.data.ResponseData[0]
              this.destinationHub = this.NDDBagData.destinationhubid
              if (this.destinationHubObjData.isbaggingpattern == true) {
                this.destinationHubObjData.isbaggingpattern = true
                this.routeModeObjData.text = "Air"
                this.routeMode = "Air"
              } else {
                this.destinationHubObjData.isbaggingpattern = false
                this.routeModeObjData = {
                  text: ""
                }
                this.routeMode = ""
              }
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.destinationHub = ""
              this.destinationHubObjData = {
                  value: "",
                  text: "",
                  isbaggingpattern: "",
                  groupid: ""
                },
                this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      }

    },

    // generateBag() {
    //     this.xbsealreasonErr = ""
    //     this.BagLoading = true
    //     this.flagGerateBag = true
    //     this.flagUpdateSealNo = false
    //     this.awbBag = ""
    //     this.awbBagErr = ""
    //     this.input = {
    //       "currentHubId": this.userHubId,
    //       "currentHubName": this.hubName,
    //       "createdBy": this.createdBy,
    //       "bagDestinationHubId": this.destinationHub,
    //       "bagType": this.bagType,
    //       "connectionId": this.connection,
    //       "isParentBag": this.bag == "ParentBag" ? true : false,
    //       "bagNumber": this.bagSealNumber,
    //       "connectionDestinationHubId": this.connectionDesHubId,
    //       "connectionType": this.connectionTypeItem.text.toLowerCase(),
    //       "parentBagSubType": this.bagSubType,
    //       "groupId": this.destinationHubObjData.groupid,
    //       "routeMode": this.routeMode,
    //       "isBikerBag": this.IsBikerBag
    //     }
    //     axios({
    //         method: 'POST',
    //         url: apiUrl.api_url_hubops + 'generateBag',
    //         data: this.input,
    //         headers: {
    //           'authorization': 'authkey xB84JJ89Hd25',
    //           'requestfrom': "WEB",
    //           'token': this.token
    //         }
    //       })
    //       .then(result => {
    //         this.BagLoading = false
    //         if (result.data.ResultCode == 100) {
    //           this.invalidTokenModal = false
    //           this.baginBagNo = result.data.BagNo.toUpperCase()
    //           this.baginBagStatus = "BagOpen"
    //           this.baginBagType = this.bagType
    //           this.flagUpdateSealNo = true
    //           this.$refs.awbBag.focus()
    //           this.$alertify.success(result.data.ReturnMessage)
    //         } else if (result.data.ResultCode == 401) {
    //           this.invalidTokenModal = true
    //           this.invalidtokenmsg = result.data.ReturnMessage
    //           this.$alertify.error(result.data.ReturnMessage)
    //         }
    //         // else if (result.data.ResultCode == 106) {
    //         //   this.invalidTokenModal = false
    //         //   this.XBSealMsg = result.data.ReturnMessage
    //         //   this.XBSealModel = true
    //         // }
    //         else {
    //           this.invalidTokenModal = false
    //           this.XBSealModel = false
    //           this.$alertify.error(result.data.ReturnMessage)
    //         }
    //         this.flagGerateBag = false
    //       }, error => {
    //         this.BagLoading = false
    //         this.flagGerateBag = false
    //         console.error(error)
    //       })
    // },
    //For XB Seal
    generateBag(type) {
      if (type == "IsXbSeal" && this.xbsealreason == '') {
        this.xbsealreasonErr = "Select Reason"
        return false
      } else {
        this.xbsealreasonErr = ""
        this.BagLoading = true
        this.flagGerateBag = true
        this.flagUpdateSealNo = false
        this.awbBag = ""
        this.awbBagErr = ""
        this.input = {
          "currentHubId": this.userHubId,
          "currentHubName": this.hubName,
          "createdBy": this.createdBy,
          "bagDestinationHubId": this.destinationHub,
          "bagType": this.bagType,
          "connectionId": this.connection,
          "isParentBag": this.bag == "ParentBag" ? true : false,
          "bagNumber": this.bagSealNumber,
          "connectionDestinationHubId": this.connectionDesHubId,
          "connectionType": this.connectionTypeItem.text.toLowerCase(),
          "parentBagSubType": this.bagSubType,
          "groupId": this.destinationHubObjData.groupid,
          "routeMode": this.routeMode,
          "isBikerBag": this.IsBikerBag,
          "allowXBSeal": this.IsAllowXBSeal,
          "sealChangedReason": this.xbsealreason,
          "isManualEntry": this.barcodeinput == true ? false : true
        }
        axios({
            method: 'POST',
            url: apiUrl.api_url_hubops + 'generateBag',
            data: this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            this.BagLoading = false
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.baginBagNo = result.data.BagNo.toUpperCase()
              this.baginBagStatus = "BagOpen"
              this.baginBagType = this.bagType
              this.flagUpdateSealNo = true
              this.IsAllowXBSeal = false
              this.xbsealreason = ''
              this.xbsealreasonErr = ''
              this.XBSealModel = false
              this.$refs.awbBag.focus()
              this.$alertify.success(result.data.ReturnMessage)
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else if (result.data.ResultCode == 106) {
              this.invalidTokenModal = false
              this.XBSealMsg = result.data.ReturnMessage
              this.XBSealModel = true
            } else {
              this.invalidTokenModal = false
              this.XBSealModel = false
              this.$alertify.error(result.data.ReturnMessage)
            }
            this.flagGerateBag = false
            user_tracker.checkUserIP(this.userData[0], "BaginProcess_GenerateBag", this.$route.path , this.input);
          }, error => {
            this.BagLoading = false
            this.flagGerateBag = false
            console.error(error)
          })
      }
    },
    closeXBSealModel() {
      this.XBSealModel = false
      this.XBSealMsg = ''
      this.IsAllowXBSeal = false
      this.xbsealreason = ''
      this.xbsealreasonErr = ''
    },
    CancelXBSeal() {
      this.IsAllowXBSeal = false
      this.xbsealreason = ''
      this.xbsealreasonErr = ''
    },
    clearXBReasonError() {
      this.xbsealreasonErr = ''
    },
    searchBag() {
      // this.$validator.reset()
      // this.errorBagSealNo = ''
      // this.bagNoError = ''
      // this.type = '',
      //   this.connection = '',
      //   this.destinationHub = '',
      //   this.connectionData = [],
      //   this.connectionObjData = {
      //     value: "",
      //     text: "",
      //     destHub: ""
      //   },
      //   this.destinationHubData = [],
      //   this.destinationHubObjData = {
      //     value: "",
      //     text: "",
      //     isbaggingpattern: "",
      //     groupid: ""
      //   },
      //   this.baginBagNo = ""
      // this.baginBagStatus = ""
      // this.baginBagType = ""
      // this.bagObjData = {
      //   value: "ParentBag",
      //   text: "Parent Bag"
      // }
      // this.bagTypeObjData = {
      //   text: ""
      // }
      // this.flagUpdateSealNo = false
      //
      // this.printBagStickerNo = ''
      //
      // this.awbBag = ""
      // this.awbBagErr = ""
      if (this.bagSealNumber.length <= 4 && this.barcodeinput == true) {
        this.bagSealNumber = '',
          this.barcodecheck = 0,
          setTimeout(function() {
            document.getElementById("bagsealno").disabled = false;
          }, this.timerdisable);
        this.$alertify.error("Use Barcode Scanner Only Or Disable Scanner Input For Manual Input")
        return false;
      }

      if (this.bagSealNumber) {
        this.errorBagSealNo = ''
        this.input = {
          "bagNumber": this.bagSealNumber
        }
        axios({
            method: 'POST',
            url: apiUrl.api_url_hubops + 'searchBagDetails',
            data: this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100 && result.data.ResponseData.length > 0) {
              this.invalidTokenModal = false
              var response = result.data.ResponseData[0]
              this.baginBagNo = response.bagno.toUpperCase()
              this.baginBagStatus = response.bagstatus
              this.baginBagType = response.bagtype
              this.bagObjData = response.isparentbag == true ? {
                value: "ParentBag",
                text: "Parent Bag"
              } : {
                value: "ChildBag",
                text: "Child Bag"
              }
              this.bagTypeObjData = {
                text: response.bagtype
              }
              this.flagUpdateSealNo = true
              this.$alertify.success(result.data.ReturnMessage)
              this.$refs.awbBag.focus()
              this.loadBagInShipmentList()
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      } else {
        this.errorBagSealNo = "The Bag Seal Number field is required."
      }

    },
    // 112233445541,42,43
    bagInscan() {
      if (this.awbBag == "") {
        this.awbBagErr = "The AWB/Bag field is required."
      } else {
        this.awbBagErr = ""
        if (this.baginBagType == "MasterBag") {
          this.input = {
            "parentBagNo": this.baginBagNo,
            "childBagNo": this.awbBag,
            "currentHubId": this.userHubId,
            "currentHubName": this.hubName,
            "createdBy": this.createdBy,
            "isManualEntry": this.manualInput
          }
          var url = apiUrl.api_url_hubops + 'childBagInProcess'
        } else {
          // if (this.connectionTypeItem.text == 'Biker') {
          //   this.input = {
          //     "currentHubId": this.userHubId,
          //     "createdBy": this.createdBy,
          //     "bagNumber": this.baginBagNo,
          //     "shippingID": this.awbBag,
          //     "currentHubName": this.hubName,
          //     "statusMarkedFrom": "WEB",
          //     "connectionType": "linehaulbiker"
          //   }
          // }
          // else {
          this.input = {
            "currentHubId": this.userHubId,
            "createdBy": this.createdBy,
            "bagNumber": this.baginBagNo,
            "shippingID": this.awbBag,
            "currentHubName": this.hubName,
            "statusMarkedFrom": "WEB",
            "isManualEntry": this.manualInput,
            "isWeighingInfraAvailable":this.isWeighingInfraAvailable,
            "rtoBagParentHubId":this.rtoBagParentHubId,
            "rtoParentHubName":this.rtoParentHubName,
            "reversePickUpParentHubID":this.reversePickUpParentHubID,
            "reversePickUpParentHubName":this.reversePickUpParentHubName

          }
          // if(this.rtoBagParentHubId){
          //   this.input.rtoBagParentHubId=this.rtoBagParentHubId
          // }
          // if(this.rtoParentHubName){
          //   this.input.rtoParentHubName=this.rtoParentHubName
          // }
          // if(this.reversePickUpParentHubID){
          //   this.input.reversePickUpParentHubID=this.reversePickUpParentHubID
          // }
          // if(this.reversePickUpParentHubName){
          //   this.input.reversePickUpParentHubName=this.reversePickUpParentHubName
          // }
          // if(this.isWeighingInfraAvailable){
          //   this.input.isWeighingInfraAvailable=this.isWeighingInfraAvailable
          // }
          // }
          var url = apiUrl.api_url_hubops + 'bagInShipmentWithRedis'
        }
        axios({
            method: 'POST',
            url: url,
            data: this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.$alertify.success(result.data.ReturnMessage)
              this.awbBag = ""
              this.manualInput = false
              this.$refs.awbBag.focus()
              this.loadBagInShipmentList();
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.$refs.awbBag.focus()
              this.$alertify.error(result.data.ReturnMessage)
            }
            user_tracker.checkUserIP(this.userData[0], "BaginProcess_BagInscan", this.$route.path , this.input);
          }, error => {
            console.error(error)
          })
      }
    },
    openPendingList() {
      if (this.destinationHubObjData.value > 0) {
        this.loadPendingList()
      } else {
        this.$alertify.error("Destination hub is required.")
      }
    },
    loadPendingList() {
      this.pendingList = []
      if (this.destinationHubObjData.value > 0) {
        this.input = {
          "currentHubId": this.userHubId,
          "destinationHubId": this.destinationHubObjData.value
        }
        axios({
            method: 'POST',
            url: apiUrl.api_url_hubops + 'pendingShipmentsCountByClientWise',
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            },
            data: this.input
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.pendingList = result.data.ResponseData
              var totalshipment = []
              var normalshipment = []
              var highvalueshipment = []
              var reversepickupshipment = []
              for (var i = 0; i < this.pendingList.length; i++) {
                totalshipment.push(Number(this.pendingList[i].totalshipmentcount))
                normalshipment.push(Number(this.pendingList[i].normalshipment))
                highvalueshipment.push(Number(this.pendingList[i].highvalueshipment))
                reversepickupshipment.push(Number(this.pendingList[i].reversepickupshipmentcount))
              }
              this.totalshipmentcount = totalshipment.reduce(function(acc, val) {
                return acc + val;
              }, 0)
              this.normalshipmentcount = normalshipment.reduce(function(acc, val) {
                return acc + val;
              }, 0)
              this.highvalueshipmentcount = highvalueshipment.reduce(function(acc, val) {
                return acc + val;
              }, 0)
              this.reversepickupshipmentcount = reversepickupshipment.reduce(function(acc, val) {
                return acc + val;
              }, 0)
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.pendingList = []
              this.invalidTokenModal = false
              // this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      }
    },
    showClientShipments(row, value, ind) {
      this.PendingListModal = true
      this.ClientWiseShipmentDetails = []
      // const index = this.viewdata.indexOf(ind);
      // if (index > -1) {
      //   this.viewdata.splice(index, 1)
      // } else {
      //   this.viewdata = [];
      //   this.viewdata.push(ind)
      this.isLoading = true
      this.input = {
        "clientId": row.clientid,
        "currentHubId": this.userHubId,
        "destinationHubId": this.destinationHubObjData.value
      }
      if (value == 'totalshipmentcount') {
        this.input.shipmentValue = ''
        this.input.isReversePick = false
      } else if (value == 'normalshipment') {
        this.input.shipmentValue = 'NormalShipment'
        this.input.isReversePick = false
      } else if (value == 'highvalueshipment') {
        this.input.shipmentValue = 'HighvalueShipment'
        this.input.isReversePick = false
      } else if (value == 'reversepickupshipmentcount') {
        this.input.shipmentValue = ''
        this.input.isReversePick = true
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'clientWiseShipmentsDetailsByClientId',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          },
          data: this.input
        })
        .then(result => {
          this.isLoading = false
          if (result.data.ResultCode == 100) {
            this.ClientWiseShipmentDetails = result.data.ResponseData
            this.invalidTokenModal = false
            this.$alertify.success(result.data.ReturnMessage)
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.ClientWiseShipmentDetails = []
            this.$alertify.error(result.data.ReturnMessage)
          }
        }), error => {
          this.isLoading = false
          console.error(error)
        }
      // }
    },
    closeShipmentList() {
      this.PendingListModal = false
    },
    loadBagInShipmentList() {
      this.inScanList = []
      this.weight = ""
      if (this.baginBagNo) {
        axios({
            method: 'GET',
            url: apiUrl.api_url_hubops + 'bagInShipmentList?bagNumber=' + this.baginBagNo,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              var bagTypeData = result.data.ResponseData
              var physicalweight = 0
              this.inScanList = result.data.ResponseData
              for (var i = 0; i < bagTypeData.length; i++) {
                physicalweight += parseFloat(bagTypeData[i].physicalweight)
              }
              this.weight = parseFloat(physicalweight).toFixed(2)
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              // this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      }
    },
    closeBag() {
      this.printBagStickerNo = ""
      this.input = {
        "bagNumber": this.baginBagNo,
        "hubId": this.userHubId,
        "hubName": this.hubName,
        "weight": this.weight,
        "createdBy": this.createdBy,
        "statusMarkedFrom": "WEB"
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'closeBag',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.$alertify.success(result.data.ReturnMessage)
            this.printBagStickerNo = this.baginBagNo
            this.loadBagInShipmentList()
            this.resetCloseBag();
            this.weight = ""
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
          user_tracker.checkUserIP(this.userData[0], "BaginProcess_CloseBag", this.$route.path , this.input);
        }, error => {
          console.error(error)
        })
    },

    resetCloseBag() {
      this.bagSealNumber = '',
        this.barcodecheck = 0,
        setTimeout(function() {
          document.getElementById("bagsealno").disabled = false;
        }, this.timerdisable);
      this.flagGerateBag = false
      this.flagUpdateSealNo = false
      this.errorBagSealNo = ''
      this.awbBag = '',
      this.manualInput = false
        this.weight = '',
        this.comment = '',
        this.shippingId = '',
        this.baginBagNo = '',
        this.baginBagStatus = '',
        this.baginBagType = ''
      this.$validator.reset()
    },

    resetBaginProcess() {
      this.barcodeinput = false,
        document.getElementById("scannerinput").checked = false,
        this.bagSealNumber = '',
        this.barcodecheck = 0,
        setTimeout(function() {
          document.getElementById("bagsealno").disabled = false;
        }, this.timerdisable);
      this.flagGerateBag = false,
        this.flagUpdateSealNo = false,
        this.errorBagSealNo = '',
        this.type = '',
        this.bag = 'ParentBag',
        this.bagType = '',
        this.connection = '',
        this.destinationHub = '',
        this.bagObjData = {
          value: "ParentBag",
          text: "Parent Bag"
        },
        // this.bagTypeData=[],
        this.bagTypeObjData = {
          text: ""
        },
        this.connectionData = [],
        this.connectionObjData = {
          value: "",
          text: "",
          destHub: ""
        },
        this.destinationHubData = [],
        this.destinationHubObjData = {
          value: "",
          text: "",
          isbaggingpattern: "",
          groupid: ""
        },
        this.awbBag = '',
        this.manualInput = false
        this.weight = '',
        this.comment = '',
        this.shippingId = '',
        this.connectionType = '',
        // this.connectionTypeList= [],
        this.connectionTypeItem = {
          value: "",
          text: ""
        },
        this.connectionDesHubId = '',
        this.baginBagNo = '',
        this.baginBagStatus = '',
        this.baginBagType = ''
      this.printBagStickerNo = ''
      this.IsBikerBag = false
      this.$validator.reset()
    },
    openShipmentModel() {
      this.showShipmentModel = true
    },
    closeShipmentModel() {
      this.showShipmentModel = false
    },
    openBagSealNoModel() {
      this.resetUpdateBagSealNoForm();
      if (this.baginBagNo == '') {
        this.oldSealNo = this.bagSealNumber
      } else {
        this.oldSealNo = this.baginBagNo
      }
      this.showBagSealNoModel = true
    },
    closeBagSealNoModel() {
      this.showBagSealNoModel = false
    },
    onGenerateBagin() {
      this.flagUpdateSealNo = false
      this.errorBagSealNo = ''
      this.bagNoError = ''
      this.printBagStickerNo = ''
      this.$validator.validateAll().then((result) => {
        if (this.bagSealNumber.length <= 4 && this.barcodeinput == true) {
          this.bagSealNumber = '',
            this.barcodecheck = 0,
            setTimeout(function() {
              document.getElementById("bagsealno").disabled = false;
            }, this.timerdisable);
          this.$alertify.error("Use Barcode Scanner Only Or Disable Scanner Input For Manual Input")
          return false;
        }
        if (result) {
          var bagSealNumber = this.bagSealNumber.split('-')
          let plsstart =new RegExp("^pls");
          let pls1start =new RegExp("^pls-");
          if (this.bag == "ParentBag" && (pls1start.test(this.bagSealNumber.toLowerCase()) == true || plsstart.test(this.bagSealNumber.toLowerCase()) == true)) {
            this.bagNoError = "Invalid Parent Bag Seal Number"
            return false;
          } else if (this.IsAllowXbSeries == 0 && this.bag == "ChildBag" && bagSealNumber[0].toLowerCase() == "xb") {
            this.bagNoError = "Invalid Child Bag Seal Number"
            return false;
          } else {
            this.flagGerateBag = true
            this.generateBag()
          }
        } else {
          console.log('errors exist', this.errors)
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },
    serachShipmentDetails() {
      this.shippingIdErrors = ""
      this.shipmentDetailsList = []
      if (this.shippingId != "") {
        axios({
            method: 'GET',
            url: apiUrl.api_url_hubops + 'suggestShipmentConnectionDestinationDetails?SourceHubID=' + this.userHubId + '&ShippingID=' + this.shippingId,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.shipmentDetailsList = result.data.ResponseData
              this.processCode = result.data.ProcessCode
              if(Object.keys(result.data.lossCategorization).length !=0){
                this.colorCode = result.data.lossCategorization.colorCode;
                this.colorIcon = result.data.lossCategorization.icon;
              }
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.showHideCodeIconInput();
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.showHideCodeIconInput();
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      } else {
        this.shippingIdErrors = "The shipping Id field is required."
      }
    },
    resetShipmentDetails() {
      this.shippingIdErrors = ""
      this.shipmentDetailsList = []
      this.showHideCodeIconInput();
      this.shippingId = ""
    },
    updateBagSealNo() {
      if (this.validUpdateBagSealNoForm()) {
        this.input = {
          "CurrentHubID": this.userHubId,
          "OldBagSealNo": this.oldSealNo,
          "NewBagSealNo": this.newSealNo,
          "SealChangedReason": this.reason,
          "LastModifiedBy": this.createdBy,
          "CurrentHubName": this.hubName,
          "statusMarkedFrom": "WEB"
        }
        axios({
            method: 'POST',
            url: apiUrl.api_url_hubops + 'updateBagSealNo',
            data: this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.$alertify.success("Bag Seal No Updated Successfully.")
              this.baginBagNo = this.newSealNo
              //this.oldSealNo  = this.newSealNo
              this.showBagSealNoModel = false
              this.resetUpdateBagSealNoForm();
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      }
    },
    resetModalFields() {
      this.reason = ''
      this.newSealNo = ''
      this.reasonErr = ''
      this.newSealNoErr = ''
    },

    validUpdateBagSealNoForm() {
      var flag = true;
      this.oldSealNoErr = ''
      this.newSealNoErr = ''
      this.reasonErr = ''
      if (this.oldSealNo == "") {
        flag = false
        this.oldSealNoErr = "Old Bag Seal No field is required."
      }
      if (this.newSealNo == "") {
        flag = false
        this.newSealNoErr = "New Bag Seal No field is required."
      }
      if (this.reason == "") {
        flag = false
        this.reasonErr = "Reason field is required."
      }
      return flag;
    },
    resetUpdateBagSealNoForm() {
      this.newSealNo = ""
      this.reason = ""
    },
    openBagList() {
      if (this.destinationHubObjData.value > 0) {
        this.loadOpenBagList()
      } else {
        this.$alertify.error("Destination hub is required.")
      }
    },
    loadOpenBagList() {
      this.openbagList = []
      if (this.destinationHubObjData.value > 0) {
        axios({
            method: 'GET',
            url: apiUrl.api_url_hubops + 'bagOpenListWebApp?currenthubid=' + this.userHubId + '&destinationhubid=' + this.destinationHubObjData.value,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.openBagHubName = "(" + this.destinationHubObjData.text + ")"
              this.openbagList = result.data.ResponseData
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      }
    },
    removeShipment(shippingId) {
      if (shippingId) {
        this.input = {
          "parentBagNo": this.baginBagNo,
          "shippingID": shippingId,
          "userHubID": this.userHubId,
          "lastModifiedBy": this.createdBy,
          "userHubName": this.hubName,
          "statusMarkedFrom": "WEB"
        }
        axios({
            method: 'POST',
            url: apiUrl.api_url_hubops + 'removeBagShipment',
            data: this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.loadBagInShipmentList()
              this.$alertify.success("Bag Shipment Successfully Remove")
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      } else {
        this.$alertify.error("Shipment ID not found")
      }
    },
    resetInSacn() {
      this.awbBag = ""
      this.manualInput = false
      this.awbBagErr = ""
      this.$refs.awbBag.focus()
    },
    cancelChildBagConModal() {
      this.IsAllowXbSeries = 0
      this.childbagConfirmationModel = false
    },
    isAllowXbSeriesCheck(event) {
      if (event == 1) {
        this.childbagConfirmationModel = true
      } else {
        this.IsAllowXbSeries = 0
        this.childbagConfirmationModel = false
      }
    },
    continueChildBagTrue() {
      this.childbagConfirmationModel = false
    },
    selectedRouteMode(obj) {
      this.routeModeObjData = obj
      this.routeMode = obj.text
    },


    resetValidator() {
      this.$validator.reset()
    },

    loadBagDetails() {
      this.input = {}
      axios({
          method: 'GET',
          'url': apiUrl.allocateRuleapi_url + 'getBagDetailsForPrintSticker?BagNo=' + this.printBagStickerNo,
          'data': this.input,
          headers: {
            'Authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          var response = result.data
          if (response.ResultCode == 100) {
            if (response.ResultData.length > 0) {
              this.bagDetails = response.ResultData[0];
              this.printerSticker(this.bagDetails)
            }
            // console.log(this.bagDetails.bagno);
          } else {
            this.bagDetails = {};
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          var code = error.response == undefined ? code = 0 : error.response.status;
          if (code == 500) {
            this.$alertify.error(error.response.statusText);
          } else {
            this.$alertify.error(error.response.statusText);
          }
          console.log(error)
        })
    },

    printerSticker(bagDetails) {
      var connectionname1 = bagDetails.connectionname.substring(0, 39);
      var connectionname2 = bagDetails.connectionname.substring(39, 82);
      var date = bagDetails.bagprintdate;
      this.input = {
        prnData: 'n\n' +
          'M0751\n' +
          'KW0400\n' +
          'O0220\n' +
          'V0\n' +
          'f303\n' +
          'D\n' +
          'L\n' +
          'D11\n' +
          'A2\n' +
          '1X1100000010100L001300\n' +
          '1e6304801990125BX' + bagDetails.bagno + '\n' +
          '1911A1201800165' + bagDetails.bagno + '\n' +
          '1911A1202670148WWW.XPRESSBEES.COM\n' +
          '1911A1001450114Destination :\n' +
          '1911A1001450220' + bagDetails.destinationhubname + '\n' +
          '1911A1001120114Bag Type :\n' +
          '1911A1001130220' + bagDetails.bagtype + '\n' +
          '1911A1000820114Route Mode\n' +
          '1911A1000820220' + bagDetails.routemode + '\n' +
          '1911A1000520114No. Of QTY :\n' +
          '1911A1000520220' + bagDetails.totalshipmentsinbag + '\n' +
          '4911A1000140039Connection :\n' +
          '4911A0800140057' + connectionname1 + '\n' +
          '4911A0800140082' + connectionname2 + '\n' +
          '1911A1000190114Date :\n' +
          '1911A1000190220' + date + '\n' +
          'Q0001\n' +
          'E',
        bagNumber: this.printBagStickerNo
      }
      axios({
          method: "POST",
          url: "http://localhost:4500/printer/printbagsticker",
          data: this.input,
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage);
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
        }, error => {
          var code = error.response == undefined ? code = 0 : error.response.status;
          if (code == 500) {
            this.$alertify.error("Printer API error");
            console.log(error.response.statusText);
          } else if (error) {
            this.$alertify.error("Printer not connected")
          }
        })
    },
    setLoading(isLoading) {
      if (isLoading) {
        this.resultCount++;
        this.isLoading = true;
      } else if (this.resultCount > 0) {
        this.resultCount--;
        this.isLoading = (this.resultCount > 0);
      }
    },
    scanBagSealNumber() {
      // var textBox = document.getElementById("bagsealno");
      // textBox.onkeypress = function(e) {
      //   e = e || window.event;
      //   var charCode = e.keyCode;
      //   if (/[^\d]/.test(String.fromCodePoint(charCode))) {
      //     return false;
      //   }
      //     if (/^[0-9]/.test(String.fromCodePoint(charCode))) {
      //       return false;
      //     }
      //
      // };
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/BaginProcessWithRedis/BaginProcessWithRedis.js